/* Davidson's Auto Gear — homepage behavior.
   Ported from the original ChatGPT-authored mockup:
   - preview/vehicle-carousel.js, verbatim (selectors adapted to the IDs
     already used in dag-home-vehicle-carousel.liquid).
   - preview/vehicle-selector.js, lines 1-26 only (ARIA-label wiring and
     loading-status detection). The local-preview-only click-interception
     block (its lines 27-42) is intentionally NOT ported: that hack only
     existed because the original mockup was a static HTML file that
     could not submit a real search, so it faked navigation by
     redirecting to a matching collection URL. On the live theme,
     EasySearch's own "Search" button submits a real request, so no
     interception is needed or wanted here. */
(() => {
  const track = document.querySelector('#dag-vehicle-track');
  const previous = document.querySelector('[data-dag-vehicle-prev]');
  const next = document.querySelector('[data-dag-vehicle-next]');
  if (!track || !previous || !next) return;

  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');

  const update = () => {
    previous.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
  };

  const move = direction => {
    const firstCard = track.firstElementChild;
    if (!firstCard) return;
    const step = firstCard.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
    track.scrollBy({ left: direction * step, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
  };

  previous.addEventListener('click', () => move(-1));
  next.addEventListener('click', () => move(1));

  track.addEventListener('keydown', event => {
    if (event.target !== track) return;
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
      event.preventDefault();
      move(event.key === 'ArrowRight' ? 1 : -1);
    }
  });

  track.addEventListener('scroll', update, { passive: true });
  new ResizeObserver(update).observe(track);
  update();
})();

(() => {
  const finder = document.querySelector('.dag-home-vehicle-finder');
  if (!finder) return;

  const status = finder.querySelector('.vehicle-status');
  const selects = finder.querySelectorAll('select');
  selects.forEach(select => {
    if (!select.getAttribute('aria-label') && select.id) {
      const label = finder.querySelector(`label[for="${select.id}"]`);
      if (label) select.setAttribute('aria-label', label.textContent.trim());
    }
  });

  if (!status) return;
  const setLoading = isLoading => {
    status.textContent = isLoading ? 'Loading vehicle options…' : status.dataset.defaultText || status.textContent;
  };
  status.dataset.defaultText = status.textContent;

  const observer = new MutationObserver(() => {
    const isBusy = finder.querySelector('[aria-busy="true"], .loading, .is-loading');
    setLoading(!!isBusy);
  });
  observer.observe(finder, { attributes: true, subtree: true, attributeFilter: ['aria-busy', 'class'] });
})();
